import { render } from "./BlogsPage.vue?vue&type=template&id=2b012d64&scoped=true"
import script from "./BlogsPage.vue?vue&type=script&lang=js"
export * from "./BlogsPage.vue?vue&type=script&lang=js"

import "./BlogsPage.vue?vue&type=style&index=0&id=2b012d64&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b012d64"]])

export default __exports__